import _ from 'lodash';

_.mixin({
  mergeByKey: function (arr1, arr2, key) {
    const dictionary = {};
    arr1.forEach(element => {
      dictionary[element[key]] = element;
    });
    const arr2Dict = {};
    arr2.forEach(element => {
      dictionary[element[key]] = _.merge(dictionary[element[key]], element);
    });

    return Object.values(dictionary);
  },
});
